<style lang="less" scoped>
@import '../../../style/common/variable';

.sjgx{width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;}
.country{width: 1200px;margin: auto;}
.first{display: block; text-align: left; margin:auto;.right{font-weight: 600;}}
.second tr{border-bottom: 1px solid red; }
table {border-collapse: collapse;}
table, th, td {border: 1px solid #ECECEC;}
.firsttd, .thirdtd{width: 240px;background-color: #FAFAFA;}
.secondtd, .forthtd{width: 360px;}
.second{display: block; margin-top:30px;margin-bottom:30px;}
.sec-table{width: 1200px;}
@media screen and (max-width: @max-screen){
  .sjgx{width: 100vw;margin: auto;}
  .main{width: 100%;}
  .first{margin: .55rem .1rem 0 .1rem;}
  table{display: table; width:95vw!important; margin: auto;}
  th{font-size: 14px; padding: 10px 6px;}
  td{font-size: 13px; padding: 10px 6px;}
}
</style>

<!--李旭 2021.7.5数据共享详情页-->
<template>
  <div class="sjgx">
    <div class="main">
      <div class="country"><National></National></div>
      <div class="first">
        <span>当前位置：</span>
        <span class="right">矿业信息服务 -> 数据共享 -> {{SjgxDet[0].endataname}}</span>
      </div>
      <div class="second">
        <table
          :data="tableData"
          border
          class="sec-table">
          <tr style="height:50px">
            <td class="firsttd">数据名称（英文）</td>
            <td class="secondtd">{{SjgxDet[0].endataname}}</td>
            <td class="thirdtd">数据名称（中文）</td>
            <td class="forthtd">{{SjgxDet[0].zhdataname}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">资料档号</td>
            <td class="secondtd">{{SjgxDet[0].dataserialnu}}</td>
            <td class="thirdtd">文件标识</td>
            <td class="forthtd">{{SjgxDet[0].filesign}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">文件类型</td>
            <td class="secondtd">{{SjgxDet[0].filetype}}</td>
            <td class="thirdtd">内容类别</td>
            <td class="forthtd">{{SjgxDet[0].contenttype}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">中心地理坐标</td>
            <td class="secondtd">{{SjgxDet[0].centergeocoordinates}}</td>
            <td class="thirdtd">东边经度</td>
            <td class="forthtd">{{SjgxDet[0].easternlongitude}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">西边经度</td>
            <td class="secondtd">{{SjgxDet[0].westlongitude}}</td>
            <td class="thirdtd">南边经度</td>
            <td class="forthtd">{{SjgxDet[0].southernlatitude}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">北边经度</td>
            <td class="secondtd">{{SjgxDet[0].northlatitude}}</td>
            <td class="thirdtd">所属国家和地区</td>
            <td class="forthtd">{{SjgxDet[0].countryname}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">数据表示方式</td>
            <td class="secondtd">{{SjgxDet[0].datashowmethodname}}</td>
            <td class="thirdtd">比例尺</td>
            <td class="forthtd">{{SjgxDet[0].scale}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">语言</td>
            <td class="secondtd">{{SjgxDet[0].language}}</td>
            <td class="thirdtd">数据所属方</td>
            <td class="forthtd">{{SjgxDet[0].dataowner}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">数据发布时间</td>
            <td class="secondtd">{{SjgxDet[0].datapublishtime}}</td>
            <td class="thirdtd">数据存储方</td>
            <td class="forthtd">{{SjgxDet[0].datastorage}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">数据提交方</td>
            <td class="secondtd">{{SjgxDet[0].datasubmit}}</td>
            <td class="thirdtd">联系人</td>
            <td class="forthtd">{{SjgxDet[0].linkman}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">联系方式</td>
            <td class="secondtd">{{SjgxDet[0].linkmethod}}</td>
            <td class="thirdtd">内容摘要</td>
            <td class="forthtd">/</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">关键词</td>
            <td class="secondtd">{{SjgxDet[0].keyword}}</td>
            <td class="thirdtd">目录</td>
            <td class="forthtd">/</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import National from '../assembly/National'
export default {
  components: {
    National
  },
  name: '',
  data()
  {
    return {
      tableData: [],
      SjgxDet: []
    }
  },
  watch:
  {
    $route:
    {
      handler(nval, oval)
      {
        this.getSjDetails(+nval.query.id)
      },
      immediate: true
    }
  },
  methods: {
    getSjDetails(itemid)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 22, _exp: 'id=? and examine = 0', types: 'i', vals: itemid}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        arr.push({
          endataname: ret[0].endataname,
          zhdataname: ret[0].zhdataname,
          contenttype: ret[0].contenttype,
          easternlongitude: ret[0].easternlongitude,
          westlongitude: ret[0].westlongitude,
          southernlatitude: ret[0].southernlatitude,
          northlatitude: ret[0].northlatitude,
          countryname: ret[0].countryname,
          datashowmethodname: ret[0].datashowmethodname,
          scale: ret[0].scale,
          language: ret[0].language,
          dataowner: ret[0].dataowner,
          datapublishtime: ret[0].datapublishtime,
          datastorage: ret[0].datastorage,
          datasubmit: ret[0].datasubmit,
          linkman: ret[0].linkman,
          linkmethod: ret[0].linkmethod,
          filetype: ret[0].filetype,
          keyword: ret[0].keyword,
          dataserialnu: ret[0].dataserialnu,
          filesign: ret[0].filesign
        })
        this.SjgxDet = arr
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/SjgxDetails.vue